import { Outlet, useNavigate } from "react-router-dom";
import { BarChart3, FileText, Users, MessageSquare } from "lucide-react";
import { useAuthCache } from "@/shared/cache";
import { TimerProvider } from "@/v2/contexts/TimerProvider";
import { AppShell } from "@/v2/components/AppShell";
import type { NavItem } from "@/v2/components/MobileBottomNav";

const navItems: NavItem[] = [
	{ path: "/admin/dashboard", label: "Dashboard", icon: BarChart3 },
	{ path: "/admin/billing", label: "Billing", icon: FileText },
	{ path: "/admin/timekeeper", label: "Timekeeper", icon: Users },
	{ path: "/admin/support", label: "Support", icon: MessageSquare },
];

export default function V2AdminLayout() {
	const { auth } = useAuthCache();
	const navigate = useNavigate();

	return (
		<TimerProvider>
			<AppShell
				navItems={navItems}
				userInitials={auth.initials}
				userDisplayName={auth.displayName}
				userEmail={auth.email}
				showRoleSwitcher
				currentRole="admin"
				onRoleSwitch={() => navigate("/tracked")}
			>
				<Outlet />
			</AppShell>
		</TimerProvider>
	);
}
